"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bookmarks = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bookmarks` : '') + (description ? ` desc-bookmarks` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bookmarks"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bookmarks"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 0.25C22.3797 0.25 22.6935 0.532154 22.7432 0.898229L22.75 1V15C22.75 15.5998 22.0898 15.9432 21.6047 15.6379L21.5211 15.5772L18.75 13.278V23C18.75 23.5827 18.1231 23.9292 17.6373 23.657L17.5481 23.5986L10 17.9L2.45189 23.5986C2.01589 23.9277 1.41358 23.692 1.27789 23.2067L1.25716 23.1064L1.25 23V5C1.25 4.6203 1.53215 4.30651 1.89823 4.25685L2 4.25H9.25V1C9.25 0.620304 9.53215 0.306509 9.89823 0.256847L10 0.25H22ZM17.25 5.75H2.75V21.494L9.54811 16.3619C9.75611 16.2049 10.0255 16.17 10.2608 16.2573L10.3593 16.3021L10.4519 16.3619L17.25 21.494L17.2492 11.8226C17.2276 11.7205 17.2273 11.6143 17.249 11.5114L17.25 5.75ZM21.25 1.75H10.75V4.25H18C18.3797 4.25 18.6935 4.53215 18.7432 4.89823L18.75 5V11.329L21.25 13.403V1.75Z",
    fill: "inherit"
  }));
};
var _default = exports.default = bookmarks;